const enGb = {
  'Welcome to React': 'Welcome to React and react-i18next',
  '404subTitle': 'Sorry, the page you visited does not exist.',
  '403subTitle': 'Sorry, you are not authorized to access this page.',
  '500subTitle': 'Sorry, something went wrong.',
  'Back Home': 'Back Home',
  'Loading': 'Loading ...',

  // 登录页
  'Please input your Username!': 'Please input your Username!',
  'Username': 'Username',
  'Please input your Password!': 'Please input your Password!',
  'Password': 'Password',
  'Confirm Password': 'Confirm Password',
  'Please confirm your password!': 'Please confirm your password!',
  'The two passwords that you entered do not match!': 'The two passwords that you entered do not match!',
  'Remember me': 'Remember me',
  'Forgot password': 'Forgot password',
  'Log in': 'Log in',
  'Or': 'Or',
  'Login!': 'Login!',
  'register now!': 'register now!',
  'Password Login': 'Password Login',
  'Verification login': 'Verification login',
  'Phone': 'Phone',
  'Please input your Phone!': 'Please input your Phone!',
  'Incorrect mobile number format!': 'Incorrect mobile number format!',
  'Verification': 'Verification',
  'Please input your Verification!': 'Please input your Verification!',
  'Incorrect format of verification number!': 'Incorrect format of verification number!',
  'Get verification code': 'Get verification code',
  'E-mail': 'E-mail',
  'The input is not valid E-mail!': 'The input is not valid E-mail!',
  'Please input your E-mail!': 'Please input your E-mail!',
  'Should accept agreement': 'Should accept agreement',
  'I have read the': 'I have read the',
  'agreement': 'agreement',
  'Register': 'Register',
  '登陆成功': 'Login succeeded',
  'Verification code verification': 'Verification code verification',
  'Reset password': 'Reset password',
  'Next step': 'Next step',
}

export default enGb
